import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { TODAYS_BIRTHDAY } from "../constant/todays-birthday.constant";

@Injectable({
  providedIn: "root",
})
export class TodaysBirthdayService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };
  constructor(private http: HttpClient) {}

  //   Basic api

  public getTodaysBirthday() {
    return this.http.get(`${TODAYS_BIRTHDAY.BIRTHDAY_NOTIFICATION}`);
  }

  public getTodaysBirthdayOnRefresh() {
    return this.http.get(`${TODAYS_BIRTHDAY.BIRTHDAY_DATA}`);
  }

  public sendSms(type, obj: any) {
    return this.http.post(`${TODAYS_BIRTHDAY.SEND_SMS}/${type}`, obj);
  }

  public addBirthday(obj: any) {
    return this.http.post(`${TODAYS_BIRTHDAY.BIRTHDAY_NOTIFICATION}`, obj);
  }
  public getCSV(payload) {
    return this.http.post(`/todays-event/export`, payload, {
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    });
  }
  public getExcelFields() {
    return this.http.get<any[]>(`/todays-event/export/fields`);
  }

getBirthdaysByDate(selectedDate: string) {
  const url = `/todays-event/birthdays-by-date`;
  return this.http.post<any>(url, { date: selectedDate });
}

public getEighteenYearOlds() {
  return this.http.get(`/todays-event/turned-18-today`);
}
}
